module.exports = __webpack_public_path__ + "475afef956ef1a7ad659bae878da81d8.pdf";